import { FeatureTypes } from '../constants/featureTypes.js';

export const isConfig = (doc) => doc.type === FeatureTypes.CONFIG; 
export const isComplexFeature = (doc) => doc.type === FeatureTypes.FEATURE; 
export const isSupportAction = (doc) => doc.type === FeatureTypes.READ || doc.type === FeatureTypes.UPDATE; 
export const isImagesConfig = (doc) => doc.type === FeatureTypes.IMAGES; 